import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ServiceMessageBrokerFactory,
  ServiceMessageBroker,
} from "shared/provider-webworker";

import { CcyLookupService } from "./CcyLookupService";
import { PrimaryLookupService } from "../../impl/PrimaryLookupService";
import { ICcyPromiseLookupService } from "../ICcyPromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";

import { CubiqWorker } from "../../../worker/CubiqWorker";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class CcyPrimaryLookupService
  extends PrimaryLookupService<string, CubiqTS.CurrencyImpl>
  implements ICcyPromiseLookupService
{
  constructor(
    protected base: CcyLookupService,
    protected factory: ServiceMessageBrokerFactory,
    protected cubiqWorker: CubiqWorker,
  ) {
    super(base, factory, CubiqTS.CurrencyImpl, cubiqWorker, "CurrencyImpl");

    cubiqWorker.isAuth(`${this.constructor.name}`).then(
      () => {
        let ccysObservable = cubiqWorker.primeStaticData<CubiqTS.CurrencyImpl>(
          CubiqTS.CurrencyImpl.name,
        );

        ccysObservable.subscribe(
          (ccys: CubiqTS.CurrencyImpl[]) => {
            this.base.prime(ccys);
          },
          (error: Error) => {
            console.debug("Currency prime failed");
            this._primed.reject(error);
          },
          () => {
            this._primed.resolve(true);
          },
        );
      },
      (reason) => {
        console.debug("CcyPrimaryLookupService: Failed to prime: " + reason);

        this._primed.resolve(false);
      },
    );

    this.broker.registerMethod("getCcy", [PRIMITIVE], this.getCcy.bind(this), this.VALUE);
  }

  getCcy(code: string): Promise<CubiqTS.CurrencyImpl> {
    return new Promise<CubiqTS.CurrencyImpl>((res, rej) => {
      res(this.base.getCcy(code));
    });
  }

  getBase(): CcyLookupService {
    return this.base;
  }
}
